import Vue from 'vue';
import Router from 'vue-router';

//A-Z
import Home from '@/module/Home/page/Home.vue';
import Registration from '@/module/Registration/page/Registration.vue';
import Register from '@/module/Register/page/Register.vue';
import RegisterOtp from './module/Register/page/RegisterOtp.vue';
import Supplementary from '@/module/Supplementary/page/Supplementary.vue';
import DownloadApp from '@/module/DownloadAppLanding/page/DownloadApp.vue';

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/registration',
            name: 'registration',
            component: Registration
        },
        {
            path: '/register/ecard',
            name: 'register',
            component: Register
        },
        {
            path: '/register/otp',
            name: 'register',
            component: RegisterOtp
        },
        {
            path: '/supplementary',
            name: 'supplementary',
            component: Supplementary
        },
        {
            path: '/landing',
            name: 'landing',
            component: DownloadApp
        },
    ]
})
